import httpClient, { makeRequestCreator } from 'utils/httpClient'

export const list = async (query: string) => {
  const client = makeRequestCreator(httpClient)
  const searchParams = new URLSearchParams({ query })
  const params = query ? `?${searchParams.toString()}` : ''
  const data = await client(`/api/carriers/${params}`)
  return data
}

interface CarrierCreate extends Omit<Carrier, 'id'> {
  rfp?: number
}

export const create = async (carrier: CarrierCreate, rfpId?: number) => {
  if (rfpId) carrier.rfp = rfpId
  const { data } = await httpClient.post('/api/carriers/', carrier)
  return data
}
